import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import img from "../../assets/images/complete.svg";
import "./Thank-you-page.scss";

class asiacellThankYouPage extends Component {
  render() {
    return (
      <div className="container-loadaing">
        <div className="loadingLayout asiacell-thankyou">
          <div className="keep-waiting">
            <div className="success-icon">
              <img src={img} alt="Complete" />
            </div>
            <div className="thankyou-content">
              <h1>
                <Trans>asiacellSubscribe.subscribeSucess</Trans>
              </h1>
              <p>
                <Trans>asiacellSubscribe.smsInfo</Trans>
              </p>
             
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(asiacellThankYouPage);
